import React, { useState, useEffect } from 'react';

import { Redirect, Route, Switch/*, useLocation*/ } from 'react-router-dom';
//import {useLocation } from 'react-router-dom';

import './App.css';

//import Login from './components/Login/Login';

import useToken from './UseToken';

import Pagina from './components/Pagina/Pagina';
//import AppForm from './components/Pagina/Forms/AppForm';



/*import politicaPrivacidade from "./components/Pagina/Conteudo/politicaPrivacidade"; */
//import termosCondicoes from "./components/Pagina/Conteudo/termosCondicoes";

import Cookies from "./components/Pagina/Cookies/Cookies";

import GoTopButton from './components/Pagina/GoTopButton/GoTopButton';

import Content from './components/Pagina/Content/Content';
// import RoutesCards from './components/Pagina/EstrelaMaior/RoutesCards';
// import Routes from './components/Pagina/EstrelaMaior/Routes';

import Store from './components/Pagina/Store/Content';

import RegistClient from "./components/Pagina/Forms/RegisterClient";
import RequestRecoveryClient from "./components/Pagina/Forms/RequestRecoveryClient";
import RecoveryClient from "./components/Pagina/Forms/RecoveryClient";

import PerfilClient from "./components/Pagina/Cliente/Perfil";
//import OrdersClient from "./components/Pagina/Cliente/Encomendas";
import HistoricClient from "./components/Pagina/Cliente/Historico";


import Loader from './loader'

//import Navbar from './components/Pagina/Navbar/Navbar';

//import CookieConsent from "react-cookie-consent";


import * as Hosts from './Hosts';

import "../src/components/Pagina/Pagina.css";

import {
  repo_favicon_link,
  set_language
} from './Utils';

// import GenericStore from './components/Pagina/GenericStore/GenericStore';
// import ProdByCategory from './components/Pagina/GenericStore/ProdByCategory';
// import ProdByCategoryDesk from './components/Pagina/GenericStore/ProdByCategoryDesk';
// import ProdByIdDesk from './components/Pagina/GoldenRock/ServiceDesk';
// import CartDesk from './components/Pagina/GoldenRock/CartDesk';
// import useContextProvider from './components/Pagina/GenericStore/Providers/ContextProvider';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom';


function App() {
  const { setToken } = useToken();

  const handleFavIcon = () => {

    function getFaviconEl() {
      return document.getElementById("favicon");
    }
    const favicon = getFaviconEl(); 

    favicon.href = repo_favicon_link("favicon.ico");
  };

  handleFavIcon()

  //LOADER TIMEOUT
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  useEffect(() => {

    console.log('11111')

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null) {
      set_language('pt')
    }

    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })

    const timer = setTimeout(() => {
      setIsLoading(false);
      //setCount('Timeout called!');
    }, 500);

    return () => clearTimeout(timer);

    /*    setTimeout(() => {
        setIsLoading(false);
      }, 500);  */
  }, [setToken])


  /*useEffect(() => {
    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })
    //console.log('token_site', Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN)

    /* setTimeout(() => {
    setLoading(false)
    /* })

  }, [])*/



  return isLoading ?
    <main>
      <Loader />
    </main>
    :
    <>
      <Cookies />
      <GoTopButton />




      <>


        {/* <Navbar /> */}
        {/*  <Pagina /> */}
        <Switch >

          <Route path='/' exact component={Pagina} />
          {/*<Route path="/app_form" exact component={AppForm} />*/}

          {/*<Route path={"/terms_conditions"} exact component={termosCondicoes} />
          <Route path={"/privacy_policy"} exact component={termosCondicoes} />
          <Route path={"/contact"} exact component={Contact} />*/}

          {/*<Route path={"/mapa_pistas"} exact component={MapaPistas} />
          <Route path={"/livecam"} exact component={LiveCam} />
        <Route path={"/accesses"} exact component={Accesses} />*/}



          <Route path={"/pag/:pag_id"} component={Content} exact={true} />

          <Route path={"/article/:article_id"} component={Content} exact={true} />
          <Route path={"/press/:press_id"} component={Content} exact={true} />
          <Route path={"/gallery/:gallery_id"} component={Content} exact={true} />
          <Route path={"/store/product/:product_id"} component={Store} exact={true} />

          <Route path={"/routes/:routes_id"} component={Content} exact={true} />
          <Route path={"/routesalt/:routesalt_id"} component={Content} exact={true} />
          <Route path={"/accommodation/:accommodation_id"} component={Content} exact={true} />
          <Route path={"/restaurant/:restaurant_id"} component={Content} exact={true} />
          <Route path={"/events/:event_id"} component={Content} exact={true} />
          <Route path={"/animation/:animation_id"} component={Content} exact={true} />
          <Route path={"/touristic/:touristic_id"} component={Content} exact={true} />

          <Route path={"/user/profile"} component={PerfilClient} exact={true} />
          <Route path={"/user/historic"} component={HistoricClient} exact={true} />

          <Route path={"/regist/client"} component={RegistClient} exact={true} />
          <Route path={"/regist/client/recovery"} component={RequestRecoveryClient} exact={true} />
          <Route path={"/regist/client/recovery/:hash"} component={RecoveryClient} exact={true} />

          <Route path={"/preview/:preview_id"} component={Content} exact={true} />

          {/*   <Route exact path={Hosts.WEB_SITE_URI + "contacts"} component={Contact} /> */}

          {/*  <Route path={Hosts.WEB_SITE_URI + "terms_conditions"} exact component={termosCondicoes} />
          <Route path={Hosts.WEB_SITE_URI + "privacy_policy"} exact component={politicaPrivacidade} /> */}
          <Route path={"/:slug"} component={Content} exact={true} />

          <Redirect to="/" />


        </Switch >
      </>



    </>


}

export default App;

